import React from 'react';
import { PropTypes } from 'prop-types';
import { DialogTitle } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import { RepliconDialog } from '~/modules/common/components';
import RescheduleProjectDialogContent from './RescheduleProjectDialogContent';

const title = <FormattedMessage id="rescheduleProject.title" />;

const rescheduleProjectRole = {
  role: 'presentation'
};

const dialogTitleId = 'reschedule-project-dialog-title';

export const RescheduleProjectDialog = ({
  open,
  onClose,
  project,
  newStartDate
}) => {
  const isMobile = useIsBreakpointDown('sm');

  return (
    <RepliconDialog
      fullScreen={isMobile}
      open={open}
      onClose={onClose}
      fullWidth
      TransitionProps={rescheduleProjectRole}
      aria-labelledby={dialogTitleId}
    >
      <DialogTitle id={dialogTitleId}>{title}</DialogTitle>
      <RescheduleProjectDialogContent
        project={project}
        onClose={onClose}
        newStartDate={newStartDate}
      />
    </RepliconDialog>
  );
};

RescheduleProjectDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  project: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  newStartDate: PropTypes.object
};

export default RescheduleProjectDialog;
